import moment from 'moment';

class Announcement {
  id?: string;

  message = '';

  startDate: Date = moment().startOf('day').toDate();

  endDate?: Date = moment().endOf('day').toDate();

  isNonWorkingDay = false;

  officeId = '';
}

export default Announcement;
